<template>
  <div class="Home order-page">
    <Header />
    <button
      v-if="reservationReturnPath"
      type="button"
      class="order-return-reservation"
      @click="$router.push(reservationReturnPath)"
    >
      Back to reservation
    </button>
    <TopSelectionBar
      @outerClick="showSidebar = false"
      :visible="showSidebar"
      :selectedPlace="SelectedPlace"
      @SelectPlace="SelectPlace($event)"
      :selectedWaiter="selectedWaiter"
      @SelectWaiter="SelectWaiter($event)"
      @SelectCustomer="SelectCustomer($event)"
      :selectedCustomer="selectedCustomer"
      @visibleHandler="
        (value) => {
          showSidebar = value;
        }
      "
    >
      <template #order-tools>
        <div class="order-meta-tools">
          <div
            v-if="
              Order.id &&
                selectedMethod.key != 'take_away' &&
                Order.items.length > 0
            "
            class="order-meta-tools__field order-meta-tools__field--view-order"
          >
            <MenuComponent
              :buttonText="selectedMethod.text"
              classes
              contentClasses="w-280"
              :autoWidth="true"
            >
              <template v-slot:content>
                <div class="plan plan-tall">
                  <div class="plan-title">
                    <h4>{{ Order.order_number }}</h4>
                    <p>
                      {{ Order.date | formatDate }}
                      {{ Order.date | formatTime }}
                    </p>
                  </div>

                  <table style="width: 100%">
                    <tr v-for="(item, index) in Order.items" :key="index">
                      <td class="text-left" v-if="item.dish">
                        <h6 class="text-left padding-top-0px">
                          {{ item.dish.name }}
                          <span
                            v-if="item.unit.name != 'item'"
                            class="text-left secondry-color font-size-8px"
                            >({{ item.unit.name }})</span
                          >
                        </h6>

                        <table class="width-100perc">
                          <tbody>
                            <tr
                              v-for="(ingredient, index) in item.ingredients"
                              :key="index"
                              class="secondry-color text-left"
                            >
                              <td width="20px" class="text-right">+</td>
                              <td>Add {{ ingredient.name }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td class="text-left" v-if="item.product">
                        <h6 class="text-left padding-top-0px">
                          {{ item.product.name }}
                        </h6>
                        <span class="text-left secondry-color font-size-8px">
                        </span>
                      </td>

                      <td></td>

                      <td class="text-right">{{ item.quantity }}</td>
                    </tr>
                  </table>

                  <a
                    v-if="!isWaiterUser && Order.table && Order.table.is_event"
                    @click="$router.push('/checkout-event/order/' + Order.id)"
                    class="btn_1 btn_scroll"
                    >Checkout</a
                  >

                  <a
                    v-else-if="!isWaiterUser"
                    @click="$router.push('/checkout/order/' + Order.id)"
                    class="btn_1 btn_scroll"
                    >Checkout</a
                  >
                </div>
              </template>

              <div
                class="dropdown-button dropdown-button--compact dropdown-button--view-order"
              >
                <span class="dropdown-text">View Order</span>
                <span class="dropdown-selected">{{ Order.order_number }}</span>
              </div>
            </MenuComponent>
          </div>

          <div class="order-meta-tools__actions">
            <button
              v-if="KOTLastBill"
              type="button"
              @click="printLastKOTBill()"
              class="order-topbar__action-btn"
            >
              KOT Bill
            </button>
            <button
              v-if="CustomerLastBill && selectedMethod.key == 'take_away'"
              type="button"
              @click="printLastBill()"
              class="order-topbar__action-btn order-topbar__action-btn--alt"
            >
              Customer Bill
            </button>
          </div>

          <div class="order-meta-tools__field order-meta-tools__field--type">
            <Multiselect
              v-model="searchType"
              selectLabel=""
              :options="searchTypes"
              placeholder="Type"
              track-by="name"
              label="name"
            >
              <span slot="noResult"
                >Oops! No elements found. Consider changing the search
                query.</span
              >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}
              </template>
            </Multiselect>
          </div>

          <div class="order-meta-tools__field order-meta-tools__field--search">
            <Multiselect
              v-if="searchType.name === 'Category'"
              v-model="selectedCategory"
              selectLabel=""
              :options="FoodCategories"
              @input="FilterDishesByCategories()"
              placeholder="Category"
              track-by="name"
              label="name"
            >
              <span slot="noResult"
                >Oops! No elements found. Consider changing the search
                query.</span
              >
            </Multiselect>
            <input
              v-else
              type="text"
              class="order-meta-tools__input"
              placeholder="Search dish"
              v-model="search"
              @input="GetAllDishes()"
              name="name_register"
              id="name_register"
            />
          </div>

          <div class="order-meta-tools__field order-meta-tools__field--method">
            <MenuComponent
              :buttonText="selectedMethod.text"
              classes="w-100"
              :list="OrderMethod"
              @selected="SelecOrderMethod($event)"
            >
              <div class="dropdown-button dropdown-button--compact">
                <span class="dropdown-text">{{ selectedMethod.text }}</span>
              </div>
            </MenuComponent>
          </div>

          <div
            v-if="selectedMethod && selectedMethod.key != 'take_away'"
            class="order-meta-tools__field order-meta-tools__field--table"
          >
            <MenuComponent
              :buttonText="tableMenuLabel"
              classes="w-100"
              :list="items"
              @selected="SelectTable($event)"
            >
              <div
                class="dropdown-button dropdown-button--compact dropdown-button--table"
              >
                <span class="dropdown-text">{{ tableRoomLabel }}</span>
                <span
                  class="dropdown-selected"
                  :class="{
                    'dropdown-selected--value': hasTableSelection,
                    'dropdown-selected--placeholder': !hasTableSelection,
                  }"
                >
                  {{ hasTableSelection ? selected.text : 'select' }}
                </span>
              </div>
            </MenuComponent>
          </div>
        </div>
      </template>
    </TopSelectionBar>

    <div class="order-page-body">
      <div class="container-fluid">
        <b-row>
          <b-col cols="7">
            <b-row class="m-0">
              <b-col cols="12" class="filters_full scrollbar pb-8 pt-4">
                <ListingFilter
                  :theme="2"
                  itemText="name"
                  v-model="selectedCategory"
                  @input="FilterDishesByCategories()"
                  :list="FoodCategories"
                />
              </b-col>
              <b-col cols="12" class="p-0">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-lg-12 p-0 pl-15">
                      <div class="ProductArea scrollbar">
                        <div class="row margin-0 mt-1">
                          <div
                            class="col-xl-3 col-lg-3 col-md-6 col-sm-6"
                            v-for="(dish, index) in Dishes"
                            :key="index"
                          >
                            <ProductView
                              :units="dish.types"
                              :dish="dish"
                              :panel-id="index"
                              :active-panel-key="activeProductPanelKey"
                              @panel-open="activeProductPanelKey = $event"
                              @Submit="AddDishToOrder($event)"
                            />
                          </div>
                          <div
                            v-if="!Dishes.length"
                            class="NoItemsMessage w-100"
                          >
                            No Items
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="5" class="p-0">
            <div class="box_booking_2 bill p-0">
              <div class="cart">
                <Span>Your Cart</Span>
              </div>

              <div class="main bill_area">
                <div class="bill_product_area">
                  <table style="width: 100%">
                    <tr class="bill-table-head">
                      <th>Items</th>
                      <th>Units</th>
                      <th>Rate</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                      <th>Actions</th>
                    </tr>
                    <template v-for="(dish, index) in OrderedFoods">
                      <tr :key="index">
                        <td class="text-left">
                          <h6 class="text-left padding-top-0px">
                            {{ dish.dishItem.name }}
                          </h6>
                        </td>
                        <td>
                          <MenuComponent
                            v-if="
                              dish &&
                                dish.dishItem &&
                                dish.dishItem.units &&
                                dish.dishItem.units.length > 1
                            "
                            style="padding-left: 25px"
                            :buttonText="dish.unit.text"
                            class="kotbtn"
                            :list="dish.dishItem.units"
                            @selected="ChangeDishUnit($event, dish)"
                          />
                        </td>
                        <td>
                          <h6 class="text-left padding-top-0px">
                            {{ dish.price }}
                          </h6>
                        </td>

                        <td>
                          <input
                            v-if="dish.unit && dish.unit.is_adjust"
                            type="number"
                            class="gram-control"
                            placeholder="Gram"
                            v-model="dish.unit.count"
                            @input="isGramValueChange(dish)"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Must be in Grams"
                          />

                          <PlusMinusInput
                            v-else
                            @count="ChangeDishQuantity($event, dish)"
                            :value="dish.count"
                            min="0"
                            type="number"
                            oninput="validity.valid||(value='');"
                          />
                          <label v-if="dish.count < 0" style="color: red"
                            >Please Enter Above Quantity 0</label
                          >
                        </td>

                        <td>
                          <h6 class="text-left padding-top-0px">
                            {{ dish.amount | price }}
                          </h6>
                        </td>

                        <td class="text-right">
                          <div
                            class="d-flex justify-content-center align-items-center gap-1"
                          >
                            <!-- Delete Icon -->
                            <a
                              @click="RemoveDishFromOrder(dish.dishItem.id)"
                              class="btn btn-sm cart-item-remove no-padding-right"
                              style="font-size: 15px"
                              data-item-index="0"
                            >
                              <span
                                style="color: black"
                                class="icon_trash_alt"
                              ></span>
                            </a>

                            <button
                              v-if="
                                dish &&
                                  dish.dishItem &&
                                  dish.dishItem.ingredients &&
                                  dish.dishItem.ingredients.length > 0
                              "
                              @click="showModal(dish)"
                              class="btn btn-sm cart-item-remove no-padding-right customizeBtn"
                              style="
                                font-size: 15px;
                                color: black;
                                line-height: 1;
                                padding: 0;
                                border: none;
                                background: none;
                              "
                            >
                              <i class="far fa-edit"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr
                        v-for="(item, index1) in dish.ingredients"
                        :key="index1"
                      >
                        <td colspan="100%" class="text-left ml-4">
                          + Add Extra {{ item.ingredient.name }} ({{
                            item.price
                          }})
                        </td>
                      </tr>
                      <tr>
                        <td colspan="100%">
                          <hr />
                        </td>
                      </tr>
                    </template>

                    <tr v-if="!OrderedFoods.length">
                      <td colspan="12" class="text-center NoItemsMessage">
                        No Items
                      </td>
                    </tr>
                  </table>
                </div>
                <div id="cart-payment" class="bill_cart-footer">
                  <!-- {{OrderedFoods}}  === {{NewlyOrdered}} -->
                  <span class="TotalAmount">
                    <b>Total Amount</b>
                    Rs.{{ totalAmountTakeAway | price }}
                  </span>
                  <span
                    v-if="
                      totalAmountTakeAway > 0 &&
                        selectedMethod.key == 'take_away'
                    "
                  >
                    <div class="row">
                      <div class="col-lg-6">
                        <input
                          type="number"
                          class="form-control"
                          v-model="ReceivedAmount"
                          placeholder="Received Amount"
                          data-toggle="tooltip"
                          data-placement="top"
                        />
                      </div>
                      <div class="col-lg-6">
                        <input
                          type="number"
                          disabled
                          class="form-control"
                          :value="calculateBalance"
                          placeholder="Balance Amount"
                          data-toggle="tooltip"
                          data-placement="top"
                        />
                      </div>
                    </div>
                  </span>
                  <div></div>
                  <span
                    v-if="
                      totalAmountTakeAway > 0 &&
                        selectedMethod.key == 'take_away'
                    "
                  >
                    <div class="row">
                      <div class="col-lg-6">
                        <Multiselect
                          v-model="payment_type"
                          selectLabel=""
                          :options="PaymentTypes"
                          placeholder="Payment Type"
                          track-by="name"
                          label="name"
                          ><span slot="noResult"
                            >Oops! No elements found. Consider changing the
                            search query.</span
                          >
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ option.name }}
                          </template>
                        </Multiselect>
                      </div>
                      <div class="col-lg-6" v-if="payment_type.name === 'Card'">
                        <input
                          class="form-control"
                          v-model="card_bank"
                          placeholder="Bank"
                          data-toggle="tooltip"
                          data-placement="top"
                        />
                      </div>
                    </div>
                  </span>
                </div>
                <hr />

                <a
                  class="btn_1 full-width mb_5"
                  style="color: white"
                  @click="FinaliseOrder()"
                  v-if="isbuttonhide"
                  >Place Order</a
                >
                <a
                  @click="OrderedFoods = []"
                  class="btn_1 full-width outline cart-cancel-btn"
                  >Cancel Bill</a
                >
                <div class="text-center">
                  <small>No payment is taken on this step.</small>
                </div>
              </div>
            </div>
          </b-col>

          <CModal
            text="customize"
            ref="ingredientModal"
            headerText="Select Ingredients"
            :width="'900'"
            submitText="Add Ingredients"
            :hideButton="true"
            @onClickSubmit="
              AddIngredientToDish(modalData, modalData.dishItem.ingredients)
            "
            :visibleFooter="true"
          >
            <template
              v-slot:content
              v-if="modalData.dishItem.ingredients.length > 0"
            >
              <div class="row">
                <div
                  v-for="(item, index) in modalData.dishItem.ingredients"
                  :key="index"
                  class="col-md-4 col-sm-6 col-xs-6 ma-5 ingrediet"
                >
                  <div
                    @click="SelectIngredientToAdd(item, modalData)"
                    data-main-menu-name="BBQ Chicken"
                    data-main-menu-code="EBC"
                    data-sub-menu-code="S"
                    data-sub-menu-price="100.0000"
                    :class="getClass(item, modalData)"
                  >
                    <span class="icon-check"></span>
                    <div class="row">
                      <div class="col-xs-12 col-sm-4 text-center">
                        <img
                          style="height: 300px; width: 600px"
                          src="@/assets/food2.jpg"
                        />
                      </div>
                      <div class="col-xs-12 col-sm-8">
                        <h4 class="margin-top-5px">
                          {{ item.ingredient.name }}
                        </h4>
                        <span class="font-size-12px">Rs.{{ item.price }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </CModal>
        </b-row>
      </div>
    </div>

    <KOTTicket
      :Method="selectedMethod.text || ''"
      :Table="selected.text || ''"
      :Order="NewlyOrdered"
      :TicketNumber="finalOutput"
      :OrderDetailsData="OrderDetails"
      v-show="false"
      ref="Bill"
      :Ordernumber="Order.order_number"
    />

    <Bill
      :Order="OrderDetailsTakeAway"
      :paymentAmount="Number(ReceivedAmount) || 0"
      :TakeawayCondition="true"
      :paymentType="payment_type && payment_type.name ? payment_type.name : ''"
      ref="TakeawayBill"
      v-show="false"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

import CheckoutBill from './Checkout';
import Bill from '../components/Share/Bill';
import {
  MenuComponent,
  PlusMinusInput,
  Button as DeleteIcon,
  Swipe,
  CustomModal as CModal,
  Progress,
} from '@/components/base/index.js';
import {
  ProductView,
  CheckboxList,
  ListingFilter,
  Header,
  KOTTicket,
  TopSelectionBar,
} from '@/components/index.js';

const iconComponent = {
  template: `
        <span class="my-icon">{{ opened ? 'I am open' : ' I am closed' }}</span>
    `,
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
};

import VueRangeSlider from 'vue-range-component';
import _ from 'lodash';
import 'vue-range-component/dist/vue-range-slider.css';
import axios from '@/plugins/axios';
import moment from 'moment';
import { RefreshButton } from '@/components/index.js';
import { mapState } from 'vuex';
import { getBrandSliderStyles } from '@/utils/kotTheme';
import { isTableLockedToOtherWaiter } from '@/utils/permissions';

export default {
  name: 'Home',
  data() {
    return {
      activeProductPanelKey: null,
      id: null,
      card_bank: '',
      payment_type: '',
      sum: 0,
      loadMore: true,
      isbuttonhide: true,
      KOTLastBill: false,
      CustomerLastBill: false,
      SelectedPlace: Object(),
      iconComponent: iconComponent,
      Customers: [],
      TakeAwayId: null,
      ReceivedAmount: null,
      balanceAmount: null,
      OrderDetails: {},
      OrderDetailsTakeAway: {},
      selectedCustomer: null,
      selectedWaiter: null,
      selected: { key: null, text: 'select' },
      completeBill: false,
      selectedMethod: { key: '1', text: 'select' },
      Order: [],
      page: 1,
      pageSize: 5,
      totalCustomers: 0,
      peymeantprice: 0,
      searchType: '',
      kotTicketNumber: [],

      searchTypes: [{ name: 'Category' }, { name: 'Dish' }],
      kotTicketLastNumber: '',
      OrdersTicketNumber: false,
      finalOutput: '',

      customerName: null,
      selectedIngredients: [],
      typesLoaded: false,
      isOrder: false,
      orderId: null,
      NewlyOrdered: [],
      today: new Date(),
      items: [],
      Rooms: [],
      Tables: [],
      PaymentTypes: [
        {
          name: 'Cash',
        },
        {
          name: 'Card',
        },
      ],
      OrderMethod: [
        {
          key: 'take_away',
          text: 'Take Away',
          disabled: false,
        },
        {
          key: 'dine_in',
          text: 'Dine In',
          disabled: false,
        },
        {
          key: 'service_order',
          text: 'Service Order',
          disabled: false,
        },
      ],
      search: null,
      selectedCategory: null,
      FoodCategories: [],
      OrderPlace: '',
      OrderedFoods: [],
      OrderedProducts: [],
      guest_id: null,
      selectedCategories: [],
      Dishes: [],
      range: 0,
      rangeBackground: {},
      modalData: { dishItem: { ingredients: [] } },
      showSidebar: false,
      loading: false,
    };
  },
  components: {
    VueRangeSlider,
    KOTTicket,
    ProductView,
    MenuComponent,
    CheckboxList,
    PlusMinusInput,
    MenuComponent,
    DeleteIcon,
    Swipe,
    ListingFilter,
    Header,
    CModal,
    RefreshButton,
    TopSelectionBar,
    Progress,
    CheckoutBill,
    Bill,
    Multiselect,
  },
  computed: {
    reservationReturnPath() {
      const queryPath = this.$route.query.returnTo;
      if (
        typeof queryPath === 'string' &&
        queryPath.indexOf('/reservation-details/') === 0
      ) {
        return queryPath;
      }
      return null;
    },
    ...mapState('sitesetting', ['setting']),
    ...mapState('orders', ['guestDetails']),
    processStyle() {
      return getBrandSliderStyles(
        this.setting && this.setting.theme_primary_color,
      ).processStyle;
    },
    tooltipStyle() {
      return getBrandSliderStyles(
        this.setting && this.setting.theme_primary_color,
      ).tooltipStyle;
    },

    tableRoomLabel() {
      if (!this.selectedMethod) return 'Table';
      return this.selectedMethod.key === 'dine_in' ? 'Table' : 'Room';
    },
    hasTableSelection() {
      return !!(this.selected && this.selected.key != null);
    },
    tableMenuLabel() {
      return this.hasTableSelection ? this.selected.text : this.tableRoomLabel;
    },
    totalAmountTakeAway: function() {
      let sumprice = 0;
      this.OrderedFoods.map((e) => {
        if (e.amount) {
          sumprice += parseFloat(e.amount);
        }
      });
      this.sum = sumprice;
      return sumprice;
    },
    calculateBalance: function() {
      let sumprice = 0;
      this.OrderedFoods.map((e) => {
        if (e.amount) {
          sumprice += parseFloat(e.amount);
        }
      });
      this.sum = sumprice;
      return (this.ReceivedAmount ? this.ReceivedAmount : 0) - sumprice;
    },
    kotKitchenId() {
      const s = this.setting;
      const id = (s && (s.kitchen_id ?? (s.kitchen && s.kitchen.id))) ?? null;
      return id != null ? id : null;
    },
    isWaiterUser() {
      const user = this.$store.state.auth && this.$store.state.auth.user;
      return Number(user && user.usertype) === 3;
    },
  },
  methods: {
    async rejectOtherWaiterTable(order) {
      let auth = this.$store.state.auth;
      if (!(auth.user && (auth.user.role || auth.user.waiter_id))) {
        try {
          await this.$store.dispatch('auth/fetchUserInfo');
        } catch (e) {
          // keep the current session; a missing profile must not sign the user out
        }
        auth = this.$store.state.auth;
      }
      if (!isTableLockedToOtherWaiter(auth, order)) return false;
      const name =
        (order && order.waiter && order.waiter.name) || 'another waiter';
      this.$fire({
        title: 'Table locked',
        text: `This table is picked by ${name}.`,
        type: 'error',
        timer: 3000,
      });
      const back = this.isWaiterUser ? '/waiter' : '/tables';
      if (this.$route.path !== back) this.$router.push(back);
      return true;
    },
    isValidCustomer(customer) {
      return !!(
        customer &&
        (customer.id || (customer.name && String(customer.name).trim()))
      );
    },
    applyDefaultCustomer() {
      if (this.isValidCustomer(this.selectedCustomer)) {
        return this.selectedCustomer;
      }
      if (this.isValidCustomer(this.guestDetails)) {
        this.selectedCustomer = this.guestDetails;
        return this.selectedCustomer;
      }
      const configGuest =
        this.setting && this.setting.guest ? this.setting.guest : null;
      if (this.isValidCustomer(configGuest)) {
        this.selectedCustomer = configGuest;
        return this.selectedCustomer;
      }
      this.selectedCustomer = { name: 'Walk-in', phone: '' };
      return this.selectedCustomer;
    },
    applyDefaultWaiter() {
      const authUser = this.$store.state.auth && this.$store.state.auth.user;
      if (authUser && authUser.waiter_id) {
        const sameWaiter =
          this.selectedWaiter &&
          Number(this.selectedWaiter.id) === Number(authUser.waiter_id);
        this.selectedWaiter = {
          id: authUser.waiter_id,
          name:
            (sameWaiter && this.selectedWaiter.name) ||
            authUser.username ||
            'Waiter',
        };
        return this.selectedWaiter;
      }
      if (this.selectedWaiter && this.selectedWaiter.id) {
        return this.selectedWaiter;
      }
      const configWaiter =
        this.setting && this.setting.waiter ? this.setting.waiter : null;
      if (configWaiter && configWaiter.id) {
        this.selectedWaiter = configWaiter;
      }
      return this.selectedWaiter;
    },
    applyDefaultPlace() {
      if (this.SelectedPlace && this.SelectedPlace.id) {
        return this.SelectedPlace;
      }
      const configPlace =
        this.setting && this.setting.place ? this.setting.place : null;
      if (configPlace && configPlace.id) {
        this.SelectedPlace = configPlace;
      }
      return this.SelectedPlace;
    },
    buildGuestPayload() {
      const customer = this.selectedCustomer || {};
      return {
        ...(customer.id ? { id: customer.id } : {}),
        name: customer.name || 'Walk-in',
        phone: customer.phone || '',
        nic_number: customer.nic_number || '',
        email: customer.email || '',
        address: customer.address || '',
      };
    },
    //Gram Value Changes
    isGramValueChange(event) {
      event.amount =
        (event.unit.price / event.unit.quantity) * event.unit.count;
    },
    //Print Last KOT Bill
    printLastKOTBill() {
      this.$refs.Bill.print();
    },

    //Print Last Customer Bill
    printLastBill() {
      this.$refs.TakeawayBill.print();
    },
    RefreshData() {
      this.loading = true;
      this.GetAllDishes();
      this.GetDishByCategories();
      var self = this;
      setTimeout(function() {
        self.loading = false;
      }, 3000);
    },
    openSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    showModal(item) {
      this.modalData = item;
      this.$refs.ingredientModal.show();
    },

    AddDishToOrder(event) {
      let food;
      if (event.dishItem.is_sellable) {
        food = this.OrderedFoods.find(
          (p) => p.dishItem.id == event.dishItem.id && p.dishItem.is_sellable,
        );
      } else {
        food = this.OrderedFoods.find(
          (p) =>
            p.dishItem.id == event.dishItem.id &&
            p.unit &&
            p.unit.key == event.unit.key &&
            p.ingredients == null &&
            !p.dishItem.is_sellable,
        );
      }
      if (food) {
        food.count = food.count + event.count;
        if (event.dishItem.is_sellable) {
          food.amount = parseFloat(event.dishItem.amount);
          food.amount =
            parseFloat(food.count) * parseFloat(event.dishItem.amount);
          food.price = parseFloat(event.dishItem.amount);
        } else {
          if (food.unit && food.unit.is_adjust) {
            food.amount =
              (parseFloat(event.unit.quantity) / parseFloat(event.unit.price)) *
              parseFloat(
                event.unit.count ? event.unit.count : event.unit.quantity,
              );
            food.price = parseFloat(event.unit.price);
            food.quantity = 1;
          } else
            food.amount = parseFloat(food.count) * parseFloat(event.unit.price);
          food.price = parseFloat(event.unit.price);
        }
      } else {
        if (event.dishItem.is_sellable) {
          event.amount =
            parseFloat(event.count) * parseFloat(event.dishItem.amount);
          event.price = parseFloat(event.dishItem.amount);
          // event.amount = parseFloat(event.dishItem.amount);
        } else {
          if (event.unit && event.unit.is_adjust) {
            event.amount =
              (parseFloat(event.unit.price) / parseFloat(event.unit.quantity)) *
              parseFloat(
                event.unit.count ? event.unit.count : event.unit.quantity,
              );
            event.price = parseFloat(event.unit.price);
            event.unit.quantity = parseFloat(event.unit.quantity);
            event.unit.count = parseFloat(event.unit.quantity);
          } else {
            event.amount =
              parseFloat(event.count) * parseFloat(event.unit.price);
            event.price = parseFloat(event.unit.price);
          }
        }

        event.selectedIngredients = [];
        this.OrderedFoods.push(event);
      }
    },

    ChangeDishUnit(event, dish) {
      dish.unit = event;
      dish.price = dish.unit.price;
      dish.amount = dish.unit.price * dish.count;
    },
    ChangeDishQuantity(event, dish) {
      if (dish.dishItem.is_sellable) {
        dish.count = event;
        dish.amount = dish.price * event;
      } else {
        dish.count = event;
        dish.amount = dish.unit.price * event;
        if (dish.ingredients) {
          dish.amount = dish.unit.price;
          dish.ingredients.forEach((item) => {
            dish.amount = parseFloat(dish.amount) + parseFloat(item.price);
          });
          dish.amount = dish.amount * event;
        }
      }
    },

    FilterDishesByCategories() {
      if (this.selectedCategory == 0) {
        this.GetAllDishes();
      } else if (this.selectedCategory == -1) {
        this.GetReadymadeProducts();
      } else {
        this.GetDishByCategories();
      }
    },
    GetDishByCategories() {
      let url = `hms/web/categories/${this.selectedCategory.id}/dishes`;
      axios
        .get(url)
        .then((res) => {
          this.Dishes = res.data;
          this.Dishes.map((dish) => {
            dish.units.map((unit) => {
              unit.text = unit.name;
              unit.key = unit.id;
            });
            dish.types = dish.units;
          });
          this.typesLoaded = true;
        })
        .catch((err) => {
          console.error('GetDishByCategories Error:', err);
        });
    },
    GetReadymadeProducts() {
      let url = `hms/web/kitchens/1/products?query=`;
      axios
        .get(url)
        .then((res) => {
          this.Dishes = res.data;

          this.Dishes.map((dish) => {
            dish.units.map((unit) => {
              unit.text = unit.name;
              unit.key = unit.id;
            });
            dish.types = dish.units;
          });
          this.typesLoaded = true;
        })
        .catch((err) => {});
    },
    async GetAllDishes() {
      let url = 'hms/web/dishes/search?';
      if (this.search != null && this.search != undefined) {
        url += `query=${this.search}&`;
      }

      axios
        .get(url)
        .then((res) => {
          this.Dishes = res.data.data;

          this.Dishes.map((dish) => {
            dish.types.map((unit) => {
              if (unit.name) {
                unit.text = unit.name;
                unit.key = unit.id;
              } else if (unit.unit) {
                unit.text = unit.unit.name;
                unit.key = unit.unit.id;
              }
            });
            dish.units = dish.types;
          });

          this.loaded = true;
        })
        .catch((err) => {
          console.error('GetAllDishes Error:', err);
        });
    },
    FinaliseOrder() {
      if (this.OrderedFoods.length == 0) {
        this.$fire({
          title: 'Error',
          text: 'Order cart is Empty',
          type: 'error',
          timer: 3000,
        }).then((r) => {});
      } else if (this.isOrder && this.selectedMethod.key != 'take_away') {
        this.AddMoreDishesToOrder();
      } else {
        this.AddNewOrder();
      }
    },

    // Get  Ticket Number For KOT Tickets
    getKitchenTicketNumber() {
      axios.get(`hms/web/kot-ticket-number`).then((res) => {
        this.kotTicketNumber = res.data.ticket_number;

        this.finalOutput = this.kotTicketNumber.substring(
          this.kotTicketNumber.lastIndexOf('-') + 1,
          this.kotTicketNumber.length,
        );
      });
    },
    async ensureTableOrder() {
      if (!this.selected || !this.selected.key) return;
      try {
        const res = await axios.get(`hms/web/tables/${this.selected.key}`);
        const order = res.data && res.data.order;
        this.isOrder = !!(res.data && res.data.is_order && order && order.id);
        this.orderId = this.isOrder ? order.id : null;
        this.Order = this.isOrder ? order : {};
        if (!this.isOrder) return;
        if (await this.rejectOtherWaiterTable(order)) return;
        if (order.guest) this.selectedCustomer = order.guest;
        if (order.place) this.SelectedPlace = order.place;
        if (order.waiter && order.waiter.id && !this.isWaiterUser) {
          this.selectedWaiter = order.waiter;
        }
      } catch (e) {
        this.isOrder = false;
        this.orderId = null;
      }
    },
    async AddNewOrder() {
      this.applyDefaultCustomer();
      this.applyDefaultWaiter();
      this.applyDefaultPlace();
      if (
        this.selectedMethod.key == 'dine_in' &&
        this.selected &&
        this.selected.key
      ) {
        await this.ensureTableOrder();
      }
      if (await this.rejectOtherWaiterTable(this.Order)) return;
      if (!this.SelectedPlace.id && this.selectedMethod.key == 'dine_in') {
        this.$fire({
          title: 'Error',
          text: 'Please select a Place for the Order',
          type: 'error',
          timer: 3000,
        }).then((r) => {});
      } else if (
        !this.SelectedPlace.id &&
        this.selectedMethod.key == 'take_away'
      ) {
        this.$fire({
          title: 'Error',
          text:
            'KOT place is not configured. Please set a default place in KOT settings.',
          type: 'error',
          timer: 4000,
        }).then((r) => {});
      } else if (!this.isValidCustomer(this.selectedCustomer)) {
        this.$fire({
          title: 'Error',
          text: 'Please select a Customer for the Order',
          type: 'error',
          timer: 3000,
        }).then((r) => {});
      } else if (this.selectedMethod.key == 'dine_in' && !this.selected.key) {
        this.$fire({
          title: 'Error',
          text: 'Please select a table for the Order',
          type: 'error',
          timer: 3000,
        }).then((r) => {});
      } else if (
        !(this.selectedWaiter && this.selectedWaiter.id) &&
        this.selectedMethod.key != 'take_away'
      ) {
        this.$fire({
          title: 'Error',
          text: 'Please select a Waiter for the Order',
          type: 'error',
          timer: 3000,
        }).then((r) => {});
      } else if (
        !this.ReceivedAmount > 0 &&
        this.selectedMethod.key == 'take_away'
      ) {
        this.$fire({
          title: 'Error',
          text: 'Please Enter Received Amount',
          type: 'error',
          timer: 3000,
        }).then((r) => {});
      } else if (!this.payment_type && this.selectedMethod.key == 'take_away') {
        this.$fire({
          title: 'Error',
          text: 'Please Select Payment Type',
          type: 'error',
          timer: 3000,
        }).then((r) => {});
      } else if (
        this.selectedMethod.key == 'take_away' &&
        this.card_bank == '' &&
        this.payment_type.name == 'Card'
      ) {
        this.$fire({
          title: 'Error',
          text: 'Please Enter Bank Name',
          type: 'error',
          timer: 3000,
        }).then((r) => {});
      } else if (!this.kotKitchenId) {
        this.$fire({
          title: 'Error',
          text:
            'KOT kitchen is not loaded. Please logout/login once, or refresh.',
          type: 'error',
          timer: 3500,
        }).then((r) => {});
      } else {
        let Credentials = new Object();
        (Credentials.date = moment(new Date()).format('MM/DD/YYYY HH:MM')),
          (Credentials.order_type = this.selectedMethod.key);
        if (this.selectedWaiter && this.selectedWaiter.id) {
          Credentials.waiter_id = this.selectedWaiter.id;
        }

        Credentials.note = 'note';
        if (this.selectedMethod.key == 'dine_in') {
          Credentials.table_id = this.selected.key;
          try {
            const mergedRaw = sessionStorage.getItem('waiter_merged_tables');
            if (mergedRaw) {
              const merged = JSON.parse(mergedRaw);
              if (
                merged &&
                Number(merged.primary_table_id) === Number(this.selected.key) &&
                Array.isArray(merged.table_ids)
              ) {
                Credentials.merged_table_ids = merged.table_ids.filter(
                  (id) => Number(id) !== Number(this.selected.key),
                );
              }
              sessionStorage.removeItem('waiter_merged_tables');
            }
          } catch (e) {
            sessionStorage.removeItem('waiter_merged_tables');
          }
        }
        if (this.selectedMethod.key == 'service_order') {
          Credentials.room_id = this.selected.key;
        }
        (Credentials.place_id = this.SelectedPlace.id),
          (Credentials.guest = this.buildGuestPayload());

        if (this.selectedCustomer.name) {
          this.OrderDetails.guest = this.selectedCustomer.name;
        }

        if (this.selectedWaiter && this.selectedWaiter.name) {
          this.OrderDetails.waiter = this.selectedWaiter.name;
        }

        // this.OrderDetails.order = this.Credentials;

        Credentials.items = [];
        Credentials.products = [];

        this.OrderedFoods.map((food) => {
          if (food.dishItem.is_sellable) {
            let item = new Object();
            (item.product_id = food.dishItem.id),
              (item.kitchen_id = this.kotKitchenId),
              // Use the user-selected unit (matches kitchen_stock.unit_id).
              (item.unit_id =
                food.unit && food.unit.key
                  ? food.unit.key
                  : Array.isArray(food.dishItem.units)
                  ? food.dishItem.units[0]?.id
                  : food.dishItem.units?.id),
              (item.quantity = food.count),
              (item.amount = food.price);

            Credentials.products.push(item);
          } else {
            var item = new Object();
            if (food.unit && food.unit.is_adjust) {
              item.dish_id = food.dishItem.id;
              item.unit_id = food.unit.key;
              item.quantity = food.count;

              item.amount =
                (food.unit.price / food.unit.quantity) *
                (food.unit.count ? food.unit.count : food.unit.quantity);

              item.adjust_quantity = food.unit.count
                ? food.unit.count
                : food.unit.quantity;
            } else {
              item.dish_id = food.dishItem.id;
              item.unit_id = food.unit.key;
              item.quantity = food.count;
              item.amount = food.unit.price;
            }

            if (food.selectedIngredients) item.ingredients = [];

            {
              food.selectedIngredients.forEach((i) => {
                let ingredient = new Object();
                ingredient.ingredient_id = i.ingredient.id;
                ingredient.quantity = 1;
                ingredient.amount = i.price;
                item.ingredients.push(ingredient);
              });
            }
            Credentials.items.push(item);
          }
        });
        this.getKitchenTicketNumber();
        this.NewlyOrdered = _.cloneDeep(this.OrderedFoods);
        this.isbuttonhide = false;
        setTimeout(() => {
          this.isbuttonhide = true;
        }, 2000);
        this.peymeantprice = this.sum;
        const addingToOpenOrder =
          this.selectedMethod.key == 'dine_in' && this.orderId;
        const placeRequest = addingToOpenOrder
          ? axios.post(`hms/web/orders/${this.orderId}/items`, {
              items: Credentials.items,
              products: Credentials.products,
            })
          : axios.post(`hms/web/orders`, Credentials);
        placeRequest
          .then((res) => {
            this.TakeAwayIndex = addingToOpenOrder ? this.orderId : res.data.id;

            this.completeBill = true;
            if (this.selectedMethod.key == 'dine_in') {
              this.OrdersTicketNumber = true;
              this.GetSelectedTableOrder();
            }

            this.completeBill = false;
            this.OrderedFoods = [];

            if (this.selectedMethod.key == 'service_order') {
              if (this.reservationReturnPath) {
                this.$router.push(this.reservationReturnPath);
                return;
              }
              this.GetOrderDetails(this.TakeAwayIndex);
            }

            if (this.selectedMethod.key == 'take_away') {
              this.GetOrderDetails(this.TakeAwayIndex);
              this.CompleteOrderTakeaway();
            }

            this.loaded = true;
            // setTimeout(() => {
            //   location.reload();
            // }, 2000);
            // this.OrderedFoods = [];
          })
          .catch((err) => {
            const message =
              (err.response &&
                err.response.data &&
                (err.response.data.message || err.response.data.error)) ||
              'Failed to place order. Please try again.';
            this.$fire({
              title: 'Error',
              text: message,
              type: 'error',
              timer: 4000,
            });
          });
      }
    },

    CompleteOrderTakeaway() {
      this.loading = true;
      let Credentials = new Object();
      Credentials.reference_number = 'sample';
      Credentials.date_time = moment(new Date()).format('MM/DD/YYYY HH:MM');
      Credentials.payment_type = this.payment_type.name;
      Credentials.amount = this.peymeantprice;
      if (this.payment_type.name == 'Card') {
        Credentials.card_bank = this.card_bank;
      } else {
        delete Credentials.card_bank;
      }

      axios
        .post(`hms/web/orders/${this.TakeAwayIndex}/payments`, Credentials)
        .then((res) => {
          this.loginSuccess = true;
          this.completeBill = true;
          this.peymeantprice = 0;
          setTimeout(() => {
            this.$refs.TakeawayBill.print();

            this.ReceivedAmount = 0;
            this.pay;
          }, 3000);
          this.CustomerLastBill = true;
          this.OrderedFoods = [];
        })
        .catch((err) => {});
    },
    GetOrderDetails(id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`hms/web/orders/${id}`)
          .then((res) => {
            this.OrderDetailsTakeAway = res.data;

            let self = this;

            setTimeout(() => {
              this.printKOTBILL();
            }, 1000);

            this.KOTLastBill = true;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    printKOTBILL() {
      this.$refs.Bill.print();
    },
    async AddMoreDishesToOrder() {
      this.applyDefaultCustomer();
      this.applyDefaultWaiter();
      this.applyDefaultPlace();
      if (!this.orderId && this.selected && this.selected.key) {
        await this.ensureTableOrder();
      }
      if (await this.rejectOtherWaiterTable(this.Order)) return;
      if (!this.orderId) {
        this.AddNewOrder();
        return;
      }
      if (!this.isValidCustomer(this.selectedCustomer)) {
        this.$fire({
          title: 'Error',
          text: 'Please select a Customer for the Order',
          type: 'error',
          timer: 3000,
        }).then((r) => {});
        return;
      }
      if (this.selectedCustomer.name) {
        this.OrderDetails.guest = this.selectedCustomer.name;
      }

      if (this.selectedWaiter && this.selectedWaiter.name) {
        this.OrderDetails.waiter = this.selectedWaiter.name;
      }
      if (this.selected) {
        this.OrderDetails.Order = this.selected;
      }

      if (!this.kotKitchenId) {
        this.$fire({
          title: 'Error',
          text:
            'KOT kitchen is not loaded. Please logout/login once, or refresh.',
          type: 'error',
          timer: 3500,
        }).then((r) => {});
        return;
      }

      let Credentials = new Object();
      Credentials.items = [];
      Credentials.products = [];
      this.OrderedFoods.map((food) => {
        if (food.dishItem.is_sellable) {
          let item = new Object();
          (item.product_id = food.dishItem.id),
            (item.kitchen_id = this.kotKitchenId),
            // Use the user-selected unit (matches kitchen_stock.unit_id).
            (item.unit_id =
              food.unit && food.unit.key
                ? food.unit.key
                : Array.isArray(food.dishItem.units)
                ? food.dishItem.units[0]?.id
                : food.dishItem.units?.id),
            (item.quantity = food.count),
            (item.amount = food.price);

          Credentials.products.push(item);
        } else {
          let item = new Object();
          if (food.unit && food.unit.is_adjust) {
            (item.dish_id = food.dishItem.id),
              (item.unit_id = food.unit.key),
              (item.quantity = food.count),
              (item.amount =
                (food.unit.quantity / food.unit.price) *
                (food.unit.count ? food.unit.count : food.unit.quantity));
            item.adjust_quantity = food.unit.count
              ? food.unit.count
              : food.unit.quantity;
          } else {
            (item.dish_id = food.dishItem.id),
              (item.unit_id = food.unit.key),
              (item.quantity = food.count),
              (item.amount = food.unit.price);
          }

          item.ingredients = [];

          (food.selectedIngredients || []).forEach((i) => {
            let ingredient = new Object();
            ingredient.ingredient_id = i.ingredient.id;
            ingredient.quantity = 1;
            ingredient.amount = i.price;
            item.ingredients.push(ingredient);
          });
          Credentials.items.push(item);
        }
      });
      this.getKitchenTicketNumber();

      this.NewlyOrdered = _.cloneDeep(this.OrderedFoods);
      this.completeBill = true;
      this.isbuttonhide = false;
      setTimeout(() => {
        this.isbuttonhide = true;
      }, 3000);
      axios
        .post(`hms/web/orders/${this.orderId}/items`, Credentials)
        .then(async (res) => {
          console.log('1 add Method');
          this.loaded = true;
          this.OrdersTicketNumber = true;

          if (this.selectedMethod.key == 'dine_in') {
            this.GetSelectedTableOrder();
          }

          if (this.selectedMethod.key == 'service_order') {
            if (this.reservationReturnPath) {
              this.$router.push(this.reservationReturnPath);
              return;
            }
            this.GetOrderDetails(this.TakeAwayIndex);
          }
          this.completeBill = true;

          this.completeBill = false;
          this.$store.commit('orders/AddGuestDetails', []);

          this.OrderedFoods = [];
        })
        .catch((err) => {
          const data = err && err.response && err.response.data;
          const message =
            (data && (data.message || data.error)) ||
            (typeof data === 'string' && data) ||
            'Could not add items to this order';
          this.$fire({
            title: 'Error',
            text: message,
            type: 'error',
            timer: 4000,
          });
        });
    },
    SelectCustomer(customer) {
      this.selectedCustomer = customer;
      this.OrderedFoods = []; // Clear cart on customer change
      this.showSidebar = false;
    },
    GetFoodCategories() {
      axios
        .get(`hms/web/categories`)
        .then((res) => {
          this.FoodCategories = res.data;
          this.typesLoaded = true;
        })
        .catch((err) => {});
    },
    GetSelectedTableOrder() {
      this.Order = [];
      axios
        .get(`hms/web/tables/${this.selected.key}`)
        .then(async (res) => {
          //print kot
          if (this.OrdersTicketNumber) {
            let self = this;

            // self.kotTicketNumber = res.data.order.items;

            // self.kotTicketLastNumber =
            //   self.kotTicketNumber[
            //     self.kotTicketNumber.length - 1
            //   ].ticket_number;

            // this.finalOutput = this.kotTicketLastNumber.substring(
            //   this.kotTicketLastNumber.lastIndexOf("-") + 1,
            //   this.kotTicketLastNumber.length
            // );
            self.OrdersTicketNumber = false;

            setTimeout(() => {
              this.printKOTBILL();
            }, 1000);

            this.KOTLastBill = true;
          }

          const loadedOrder = res.data && res.data.order;
          this.isOrder = !!(
            res.data &&
            res.data.is_order &&
            loadedOrder &&
            loadedOrder.id
          );
          this.orderId = this.isOrder ? loadedOrder.id : null;
          this.Order = this.isOrder ? loadedOrder : {};
          if (this.isOrder) {
            if (await this.rejectOtherWaiterTable(loadedOrder)) return;
            if (this.Order.guest) this.selectedCustomer = this.Order.guest;
            if (this.Order.place) this.SelectedPlace = this.Order.place;
            if (
              this.Order.waiter &&
              this.Order.waiter.id &&
              !this.isWaiterUser
            ) {
              this.selectedWaiter = this.Order.waiter;
            }
            this.OrderPlace = this.Order.name;
          }
        })
        .catch((err) => {});
    },

    SelectTable(event) {
      this.selected = event;
      this.OrderedFoods = []; // Clear cart on table change

      if (this.selectedMethod.text == 'Dine In') {
        this.GetSelectedTableOrder();
      }
    },
    AddIngredientToDish(dish) {
      dish.ingredients = dish.selectedIngredients;
      dish.amount = parseFloat(dish.price);
      dish.selectedIngredients.forEach((ingredient) => {
        dish.amount = parseFloat(dish.amount + parseFloat(ingredient.price));
      });
      dish.price = parseFloat(dish.amount);

      dish.amount = parseFloat(dish.amount) * parseFloat(dish.count);
      this.$refs.ingredientModal.hide();
    },
    SelecOrderMethod(event) {
      this.selectedMethod = event;
      if (event.key === 'take_away') {
        this.selected = { key: null, text: 'select' };
        return;
      }
      this.selected = { key: null, text: 'select' };
      if (event.key === 'dine_in') {
        this.items = this.Tables;
      }
      if (event.key === 'service_order') {
        this.items = this.Rooms;
      }
    },
    GetTables() {
      axios
        .get(`hms/web/tables`)
        .then((res) => {
          res.data.map((p) => {
            this.Tables.push({
              key: p.id,
              text: p.name,
            });
          });

          console.log(
            this.selectedMethod.text,
            '***************************************************',
          );
          if (this.selectedMethod.text == 'Dine In') {
            this.items = this.Tables;
            let s = this.Tables.find((p) => p.key == this.id);
            if (s) {
              this.selected = s;
            }
            this.GetSelectedTableOrder();
          }
          this.typesLoaded = true;
        })
        .catch((err) => {
          console.error('GetTables Error:', err);
        });
    },
    RemoveDishFromOrder(event) {
      let index = this.OrderedFoods.findIndex((d) => d.dishItem.id == event);
      if (index != -1) {
        this.OrderedFoods.splice(index, 1);
      }
    },
    SelectIngredientToAdd(item, dish) {
      let index = dish.selectedIngredients.findIndex(
        (p) => p.ingredient.id == item.ingredient.id,
      );
      if (index != -1) {
        dish.selectedIngredients.splice(index, 1);
      } else {
        dish.selectedIngredients.push(item);
      }
    },
    async Initialise() {
      this.selectedMethod.text = this.$route.params.type;
      if (this.$route.params.type == 'table') {
        this.selectedMethod.text = 'Dine In';
        this.selectedMethod.key = 'dine_in';
      }
      if (this.$route.params.type == 'take-away') {
        this.selectedMethod.text = 'Take Away';
        this.selectedMethod.key = 'take_away';
      }
      if (this.$route.params.type == 'room') {
        this.selectedMethod.text = 'Service Order';
        this.selectedMethod.key = 'service_order';
      }
      this.id = this.$route.params.id;
    },
    GetRooms() {
      axios
        .get(`hms/rooms`)
        .then((res) => {
          res.data.data.map((p) => {
            this.Rooms.push({
              key: p.id,
              text: p.name,
            });
          });
          if (this.selectedMethod.text == 'Service Order') {
            this.items = this.Rooms;

            let r = this.Rooms.find((p) => p.key == this.id);
            if (r) {
              this.selected = r;
            }
          }
          this.typesLoaded = true;
        })
        .catch((err) => {
          console.error('GetRooms Error:', err);
        });
    },
    getClass(item, dish) {
      if (
        dish.selectedIngredients.find(
          (p) => item.ingredient.id == p.ingredient.id,
        )
      ) {
        return 'menu-modifier-multi-selected';
      } else {
        return 'modifier menu-modifier-multi menu-modifier';
      }
    },
    SelectPlace(event) {
      this.SelectedPlace = event;
      this.showSidebar = false;
    },
    SelectWaiter(event) {
      this.selectedWaiter = event;
      console.log('Atlast', event);
      this.showSidebar = false;
    },
  },
  async created() {
    try {
      const token = localStorage.getItem('jhms_token');
      if (token) {
        await this.$store.dispatch('sitesetting/GetSettings');
      }
    } catch (e) {
      // settings are required for kot defaults; axios interceptor may redirect on auth failures
    }
    this.Initialise();
    this.GetFoodCategories();
    this.GetAllDishes();
    this.GetTables();
    if (this.selectedMethod.key === 'service_order') {
      this.GetRooms();
    }

    if (this.setting) {
      this.SelectedPlace = this.setting.place || this.SelectedPlace;
      this.selectedWaiter = this.setting.waiter || this.selectedWaiter;
    }

    this.applyDefaultCustomer();
  },
  watch: {
    setting(value) {
      if (!value || this.isValidCustomer(this.selectedCustomer)) return;
      if (this.isValidCustomer(value.guest)) {
        this.selectedCustomer = value.guest;
      }
    },
    guestDetails(value) {
      if (this.isValidCustomer(value)) {
        this.selectedCustomer = value;
      }
    },
  },
  mounted() {},
  filters: {
    price: function(value) {
      return value.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.order-return-reservation {
  display: inline-flex;
  margin: 8px 16px 0;
  padding: 6px 12px;
  border: 1px solid var(--brand-primary, #512d82);
  border-radius: 8px;
  background: #fff;
  color: var(--brand-primary, #512d82);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.TotalAmount {
  font-size: 22px;
}

#Home {
  img {
    max-width: 400px;
  }
}

.ProductArea {
  height: calc(100vh - 220px);
  min-height: 260px;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  margin-top: 8px;
}

.order-page-body {
  padding-bottom: 24px;
}

.btnType {
  background: #636363 !important;
  color: white !important;
  width: 46%;
  display: block !important;
}

.btnType:hover {
  background: #383838 !important;
  color: white;
  width: 46%;
}

.tableHead {
  background-color: var(--brand-primary, var(--brand-primary));
  color: white;
  padding: 3px;
}

.margin-0 {
  margin-right: 0px !important;
}

.w-100 {
  width: 100% !important;
}

.headerBtn {
  color: #353535;
  background-color: white !important;
  width: 46%;
  display: block !important;
}

.headerbtn:hover {
  background-color: white !important;
  color: #ff3008 !important;
  border-color: #ff3008 !important;
}

.Home {
  background-image: url('../assets/img/body-pattern.jpg');
}

.order-page .filters_full {
  padding-top: 8px !important;
}

.order-topbar {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  flex-wrap: nowrap;
}

.order-meta-tools {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.order-meta-tools__field {
  min-width: 0;
  display: flex;
  align-items: center;
}

.order-meta-tools__field > * {
  width: 100%;
}

.order-meta-tools__field--view-order {
  flex: 0 0 auto;
  min-width: 148px;
  max-width: 200px;
}

.order-meta-tools__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.order-meta-tools .dropdown-button--view-order {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  min-width: 132px;
  padding: 3px 10px;
  line-height: 1.15;
  text-align: center;
}

.order-meta-tools .dropdown-button--view-order .dropdown-text {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
}

.order-meta-tools .dropdown-button--view-order .dropdown-selected {
  font-size: 11px;
  font-weight: 700;
  color: var(--brand-primary);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-meta-tools__field--type {
  flex: 0 0 108px;
  width: 108px;
}

.order-meta-tools__field--search {
  flex: 0 0 120px;
  width: 120px;
}

.order-meta-tools__field--method {
  flex: 0 0 108px;
  width: 108px;
}

.order-meta-tools__field--table {
  flex: 0 0 112px;
  width: 112px;
}

.order-meta-tools__field--table ::v-deep .antialiased {
  min-height: 0;
  background: transparent;
}

.order-meta-tools .dropdown-button--table {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  padding: 3px 8px;
  line-height: 1.15;
  text-align: center;
}

.order-meta-tools .dropdown-button--table .dropdown-text {
  flex: none;
  width: 100%;
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  text-align: center;
  line-height: 1.15;
}

.order-meta-tools .dropdown-button--table .dropdown-selected {
  display: block !important;
  flex: none;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  line-height: 1.15;
}

.order-meta-tools .dropdown-button--table .dropdown-selected--placeholder {
  font-size: 10px;
  font-weight: 600;
  color: #c53a2a;
  text-transform: lowercase;
}

.order-meta-tools .dropdown-button--table .dropdown-selected--value {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  text-transform: none;
}

.order-meta-tools__input {
  width: 100%;
  height: 34px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.14);
  box-sizing: border-box;
}

.order-meta-tools__input::placeholder {
  color: #94a3b8;
  font-weight: 500;
}

.order-meta-tools__input:focus {
  outline: none;
  border-color: var(--brand-primary-border);
  box-shadow: 0 0 0 2px var(--brand-primary-fade-20),
    0 2px 6px rgba(15, 23, 42, 0.08);
}

.order-meta-tools ::v-deep .multiselect {
  width: 100%;
  min-height: 34px;
  font-size: 12px;
}

.order-meta-tools ::v-deep .multiselect__tags {
  min-height: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.14);
}

.order-meta-tools ::v-deep .multiselect__single,
.order-meta-tools ::v-deep .multiselect__placeholder {
  position: static;
  display: block;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 34px;
  text-align: center;
  color: #334155;
}

.order-meta-tools ::v-deep .multiselect__placeholder {
  color: #64748b;
  font-weight: 500;
}

.order-meta-tools ::v-deep .multiselect__select {
  height: 34px;
  width: 28px;
  right: 0;
  top: 0;
  padding: 0;
}

.order-meta-tools ::v-deep .multiselect__select::before {
  border-color: #64748b transparent transparent;
}

.order-meta-tools .dropdown-button--compact {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 34px;
  min-height: 34px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.14);
}

.order-meta-tools .dropdown-button--compact .dropdown-text {
  flex: none;
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  text-align: center;
  line-height: 1.2;
}

.order-meta-tools
  .dropdown-button--compact:not(.dropdown-button--table)
  .dropdown-selected {
  display: none;
}

.order-topbar__field {
  min-width: 0;
}

.order-topbar__field--type {
  flex: 0 0 108px;
}

.order-topbar__field--search {
  flex: 1 1 180px;
  min-width: 120px;
}

.order-topbar__field--table,
.order-topbar__field--method,
.order-topbar__field--order {
  flex: 0 0 118px;
}

.order-topbar__input {
  width: 100%;
  height: 34px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  color: #1e293b;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);
  box-sizing: border-box;
}

.order-topbar__input::placeholder {
  color: #94a3b8;
}

.order-topbar__input:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.35),
    0 2px 8px rgba(15, 23, 42, 0.14);
}

.order-topbar__actions,
.order-meta-tools__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.order-topbar__action-btn {
  height: 34px;
  padding: 0 10px;
  border: none;
  border-radius: 8px;
  background: var(--brand-primary, var(--brand-primary));
  color: #fff !important;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.order-topbar__action-btn--alt {
  background: var(--brand-primary-light);
}

.order-topbar ::v-deep .multiselect {
  min-height: 34px;
  font-size: 12px;
}

.order-topbar ::v-deep .multiselect__tags {
  min-height: 34px;
  padding: 4px 32px 0 8px;
  border-radius: 8px;
  border: none;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);
}

.order-topbar ::v-deep .multiselect__single,
.order-topbar ::v-deep .multiselect__placeholder {
  font-size: 12px;
  line-height: 24px;
  margin-bottom: 0;
}

.order-topbar ::v-deep .multiselect__select {
  height: 32px;
}

.dropdown-button--compact {
  height: 34px;
  padding: 2px 8px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);
}

.dropdown-button--compact .dropdown-text {
  font-size: 12px;
  line-height: 1.2;
}

.dropdown-button--compact .dropdown-selected {
  font-size: 11px;
}

@media (max-width: 991px) {
  .order-topbar {
    flex-wrap: wrap;
    row-gap: 6px;
  }

  .order-topbar__field--table,
  .order-topbar__field--order {
    flex: 1 1 calc(50% - 8px);
  }

  .order-meta-tools {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .order-meta-tools__field--type,
  .order-meta-tools__field--search,
  .order-meta-tools__field--method,
  .order-meta-tools__field--table {
    flex: 0 0 auto;
    width: auto;
    min-width: 100px;
  }
}

.downIcon:after {
  content: '\33';
  font-family: 'ElegantIcons';
}

.dropdown-button {
  position: relative;
  z-index: 1;
  height: 34px;
  padding: 2px 8px;
  border-radius: 8px;
  background: #ffffff;
  text-align: left;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1);
}

.dropdown-button:hover {
  background: #d6d6d6;
}

.dropdown-text {
  color: #1d1d1d;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.dropdown-selected,
.dropdown-text {
  display: block;
}

.dropdown-selected {
  // display: none;
  overflow: hidden;
  width: 100%;
  color: #d11f20;
  font-size: 12px;
  font-size: 0.8rem;
  line-height: 1.1;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}

.box_booking_2 ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #333;
  margin-bottom: 0rem;
}

.box_booking_2 li {
  float: left;
}

.box_booking_2 li a {
  display: block;
  color: white;
  text-align: left;
  padding: 5px 60px;
  text-decoration: none;
  font-size: 10px;
}

.box_booking_2 ul li i {
  color: #f3f3f3;
}

.p-7 {
  padding: 7px;
}

.p-0 {
  padding: 0 !important;
}

.pt-8 {
  padding-top: 8px;
}

.pb-8 {
  padding-bottom: 8px;
}

.pl-15 {
  padding-left: 15px !important;
}

.bill {
  background: #f3f3f3;
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* Match cart header width — override .box_booking_2 .main { padding: 25px } */
.order-page .box_booking_2.bill .bill_area.main {
  width: 100%;
  max-width: 100%;
  padding: 0 !important;
  box-sizing: border-box;
}

.bill_area {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.bill_product_area {
  flex: 1 1 auto;
  width: 100%;
  min-height: 120px;
  max-height: calc(100vh - 420px);
  overflow-y: auto;
}

.bill_product_area table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}

.bill_cart-footer {
  flex-shrink: 0;
  width: 100%;
  padding: 12px 14px;
  box-sizing: border-box;
}

.order-page .box_booking_2.bill .bill_area > hr {
  margin: 0;
  width: 100%;
}

.order-page .box_booking_2.bill .bill_area .btn_1.full-width {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 0;
  margin-left: 0;
  margin-right: 0;
}

.order-page .box_booking_2.bill .bill_area .text-center {
  padding: 8px 14px 12px;
  box-sizing: border-box;
}

.cart {
  width: 100%;
  padding: 14px;
  color: #fff;
  background: linear-gradient(
    90deg,
    var(--brand-primary-dark) 0%,
    var(--brand-primary) 55%,
    var(--brand-primary-light) 100%
  );
  font-size: 17px;
  font-weight: 600;
}

.bill-table-head th,
.bill_area table tr.bill-table-head th {
  background: var(--brand-primary);
  color: #fff;
  font-weight: 600;
  padding: 10px 8px;
  border: none;
}

.order-page .bill a.cart-cancel-btn.btn_1.outline {
  background: #fff !important;
  color: var(--brand-primary) !important;
  border: 2px solid var(--brand-primary) !important;
  font-weight: 600;
}

.order-page .bill a.cart-cancel-btn.btn_1.outline:hover {
  background: var(--brand-primary-muted) !important;
  color: var(--brand-primary-hover) !important;
  border-color: var(--brand-primary-hover) !important;
}

.cart:before {
  content: '\e015';
  font-family: 'ElegantIcons';
  margin-right: 13px;
}

.w-280 {
  width: 280px;
}

.secondry-color {
  color: rgb(117, 117, 117) !important;
}

.text-left {
  text-align: left;
  font-size: 14px;
}

.basket-area .single-item h5 span {
  font-size: 10px;
  padding-top: 2px;
}

.menu-modifier-multi img {
  max-height: 48px !important;
  max-width: 74px;
}

.menu-modifier-multi-selected img {
  max-height: 48px !important;
  max-width: 74px;
}

.menu-modifier,
.menu-modifier-multi {
  border: 1px solid #ccc;
  padding: 6px;
  cursor: pointer;
  margin-bottom: 15px;
  min-height: 62px;
  /* background-color: #e13340; */
  margin-top: 5px;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  border-radius: 5px;
}

.menu-modifier-selected .icon-check {
  display: inline;
}

.saveButton {
  align-content: center;
}

.menu-modifier .icon-check,
.menu-modifier-multi .icon-check {
  color: #70a401;
  position: absolute;
  z-index: 1;
  bottom: 25px;
  right: 25px;
  font-weight: bold;
  display: none;
}

.ingrediet {
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.menu-modifier-multi-selected {
  border: 1px solid #ccc;
  padding: 6px;
  cursor: pointer;
  margin-bottom: 15px;
  min-height: 62px;
  margin-top: 5px;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  border-radius: 5px;
  background-color: #daf5a2;
}

.menu-modifier {
  border: 1px solid #c5df8e;
}

.bill_product_area hr {
  border-color: #e2e2e2;
  margin: 5px;
}

.customizeBtn {
  border: none;
  color: black !important;
  border-radius: 7px;
  font-size: 12px;
  white-space: nowrap;
  display: inline-block;
}

.shared-04 {
  cursor: pointer;
  font-size: 12px !important;
  width: 100%;
}

.pac-target-input:not(:-webkit-autofill) {
  animation-name: endBrowserAutofill;
}

.round-icon-btn {
  border: 1px #5c5c5c solid;
  font-size: 16px;
  color: #4d4d4d;
  border-radius: 100px;
  display: inline-block;
  min-width: 45px;
  height: 35px;
  margin-left: 10px;
  margin-top: 5px;
  float: right;
  text-align: center;
  vertical-align: middle;
  padding-top: 7px;
  font-weight: 600;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  opacity: 0.8;
  cursor: pointer;
}

.width-100perc {
  width: 100% !important;
}

.customersList {
  height: 450px;
  width: auto;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.menuBtn {
  border-radius: 30%;
  height: 40px;
  width: 40px;
  font-size: 18px;
  background: #66ad4d;
  border: none;
  outline: none;
  color: white;
}

.KOTButton {
  border-radius: 8px;
  height: 34px;
  width: auto;
  min-width: 88px;
  padding: 0 10px;
  font-size: 12px;
  background: #66ad4d;
  border: none;
  outline: none;
  color: white;
}

.KOTButton2 {
  border-radius: 8px;
  height: 34px;
  width: auto;
  min-width: 100px;
  padding: 0 10px;
  font-size: 12px;
  margin-left: 18px !important;
  background: #66ad4d;
  border: none;
  outline: none;
  color: white;
}

.menuBtn:hover {
  background: var(--brand-primary);
}

.menuBtn span {
  margin-top: 2px;
}

nav.float-action-button[data-v-6b92200b] {
  z-index: 999;
}

.gram-control {
  padding: 0px;
  width: 71px;
  height: 31px;
  font-size: 11px;
  font-size: -11.125rem;
  border-radius: 4px;
  border: 1px solid #d2d8dd;
}

.p-11 {
  padding: 11px;
}
</style>
